import { Component, Event, EventEmitter, h, Host, Prop } from '@stencil/core';

import wcShared from '@web-components/shared';

import { Store } from '../../../../../../../../utils/Stores/store';

@Component({
  tag: 'chat-message-select-component',
  styleUrl: 'chat-message-select-module.scss',
  shadow: true,
})
export class ModuleChatMessageSelect {
  @Prop() readonly message: IWCChatMessage;
  @Prop() readonly lastMessage: { total: number; index: number };

  @Event() selectValue: EventEmitter<{ value: string; type: string }>;

  private changeSelect(event) {
    const selectedItem = (this.message?.action as IWCChatMessageValue[])?.find(
      (item) => item.value === event.target.value,
    );
    this.selectValue.emit({ value: selectedItem.value, type: 'text' });
    if (Boolean(this.message.type)) {
      Store?.set('messageData', {
        ...Store?.get('messageData'),
        service_slug: selectedItem.value,
      });
    }
  }

  render() {
    switch (this.message.type) {
      case 'select_service':
        return (
          <Host>
            <div class="message-select message-select-services">
              <span class="message-select__title">{this.message?.title}</span>
              <select
                onChange={(event) => this.changeSelect(event)}
                disabled={this.lastMessage?.total !== this.lastMessage?.index}
              >
                <option
                  value=""
                  selected
                  disabled
                  hidden
                >
                  {wcShared?.translate('Selectionner')}
                </option>
                {(this.message?.action as IWCChatMessageValue[])?.map((action) => {
                  return (
                    <option
                      value={action?.value}
                      selected={this.message[0]}
                    >
                      {action?.label}
                    </option>
                  );
                })}
              </select>
            </div>
          </Host>
        );
      default:
        return (
          <Host>
            <div class="message-select message-select-default">
              <span>{this.message?.title}</span>
              <select
                onChange={(event) => this.changeSelect(event)}
                disabled={this.lastMessage?.total !== this.lastMessage?.index}
              >
                <option
                  value=""
                  selected
                  disabled
                  hidden
                >
                  {wcShared?.translate('Selectionner')}
                </option>
                {(this.message?.action as IWCChatMessageValue[])?.map((action) => {
                  return (
                    <option
                      value={action?.value}
                      selected={this.message[0]}
                    >
                      {action?.label}
                    </option>
                  );
                })}
              </select>
            </div>
          </Host>
        );
    }
  }
}
